import React from 'react';

class FinanceCalculator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            interestRate: 1.5,
            initialInvestmet: 40000,
            yearlyIncome: [8000, 9200.00, 10000.00, 12000.00, 14500.00]
        }

        this.calcualteNpv = this.calcualteNpv.bind(this);
        this.changeInterestRate = this.changeInterestRate.bind(this);
        this.changeInitialInvestmet = this.changeInitialInvestmet.bind(this);
        this.changeYearlyIncome = this.changeYearlyIncome.bind(this);
        this.addYearlyIncome = this.addYearlyIncome.bind(this);
        this.removeYearlyIncome = this.removeYearlyIncome.bind(this);
        this.changeKwh = this.changeKwh.bind(this);
        this.changeLv = this.changeLv.bind(this);
    }

    calcualteNpv() {
        let yearResults = 0;

        for (let index = 0; index < this.state.yearlyIncome.length; index++) {
            const element = parseFloat(this.state.yearlyIncome[index]);

            yearResults += element / Math.pow(1 + parseFloat(this.state.interestRate), index + 1);
        }

        return yearResults - parseFloat(this.state.initialInvestmet);
    }

    changeKwh(event) {
        this.setState({ kwh: event.target.value });
    }

    changeLv(event) {
        this.setState({ lv: event.target.value });
    }

    changeInterestRate(event) {
        this.setState({ interestRate: event.target.value });
    }

    changeInitialInvestmet(event) {
        this.setState({ initialInvestmet: event.target.value });
    }

    changeYearlyIncome(event, i) {
        let value = event.target.value;

        this.setState((prevState, _) => {
            let newList = [...prevState.yearlyIncome];
            newList[i] = value;

            return { yearlyIncome: newList };
        });
    }

    addYearlyIncome() {
        this.setState((prevState, _) => {
            let newList = [...prevState.yearlyIncome, 0];

            return { yearlyIncome: newList };
        });
    }

    removeYearlyIncome(index) {
        this.setState((prevState, _) => {
            let newList = prevState.yearlyIncome.filter((_, i) => i !== index);

            return { yearlyIncome: newList };
        });
    }

    render() {
        return <div>
            <div className="columns is-mobile is-centered">
                <div className="column is-half">
                    <div className="container">
                        <div className="notification">
                            <div class="field">
                                <label class="label">Описание на пакета</label>
                                <div class="control">
                                    <textarea class="textarea" placeholder="Смяна на дограмата.."></textarea>
                                </div>
                            </div>

                            <table className="table is-fullwidth">
                                <tbody>
                                    <tr>
                                        <td>Годишна дисконтова ставка (лихвен процент)</td>
                                        <td><input className="input" type="text" value={this.state.interestRate} onChange={this.changeInterestRate} placeholder="Въведете стойност" /></td>
                                    </tr>
                                    <tr>
                                        <td>Начална стойност на инвестицията (лв.)</td>
                                        <td><input className="input" type="text" value={this.state.initialInvestmet} onChange={this.changeInitialInvestmet} placeholder="Въведете стойност" /></td>
                                    </tr>
                                    <tr>
                                        <td>Годишни доходи:</td>
                                        <td></td>
                                    </tr>
                                    {this.state.yearlyIncome.map((y, i) => {
                                        return <tr key={i}>
                                            <td>Доход за {i + 1}-та година</td>
                                            <td>
                                                <div className="field has-addons">
                                                    <div className="control">
                                                        <input className="input" type="text" placeholder="Въведете стойност" value={y} onChange={(event) => this.changeYearlyIncome(event, i)} />
                                                    </div>
                                                    <div className="control">
                                                        <button className="button is-info" onClick={() => this.removeYearlyIncome(i)}>X</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    })}
                                    <tr>
                                        <td><button className="button is-success is-rounded" onClick={this.addYearlyIncome}>Добави</button></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Нетна настояща стойност на инвестицията</th>
                                        <th>{this.calcualteNpv()} лв.</th>
                                    </tr>
                                </tfoot>
                            </table>
                            <fieldset class="box">
                                <div>

                                    <div class="field">
                                        <label class="label">Пресмятане на "kWh" в "лв."</label>
                                    </div>
                                    <div class="field is-horizontal">

                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <input class="input" type="text" placeholder="kWh" value={this.state.kwh} onChange={this.changeKwh} />
                                                </p>
                                            </div>
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <input class="input" type="email" placeholder="лв за kWh" value={this.state.lv} onChange={this.changeLv} />
                                                </p>
                                            </div>
                                            <div class="field-label is-normal">
                                                <label class="label">=</label>
                                            </div>
                                            <div class="field-label is-normal">
                                                <label class="label">{parseFloat(this.state.kwh || 0) * parseFloat(this.state.lv || 0)} лв.</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default FinanceCalculator;